<template>
  <Modal v-if="showModalAddPhoneNumber" @close="$emit('closeModal')">
    <Loading v-if="loading" />
    <div class="addPhoneNumber">
      <div class="addPhoneNumber__header">
        <span class="title">{{ $t('addPhoneNumber') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt="CloseModal"
          @click="$emit('closeModal')"
        />
      </div>
      <div class="addPhoneNumber__body">
        <label :for="phoneNumber">{{ $t('phoneNumber') }}</label>
        <input type="text" v-model="phoneNumber" validation="required" />
      </div>
      <div class="addPhoneNumber__buttons">
        <Button
          variant="filled"
          :title="$t('assignReservation')"
          @click="$emit('assignReservation', phoneNumber)"
        />
        <Button
          variant="redBordered"
          :title="$t('cancel')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import Loading from '@/views/Loading.vue';

@Options({
  name: 'AddPhoneNumber',
  props: ['showModalAddPhoneNumber', 'activeBoxId', 'activeLocker'],
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      phoneNumber: ''
    };
  },
  methods: {}
})
export default class AddPhoneNumber extends Vue {}
</script>

<style lang="scss" scoped>
.addPhoneNumber {
  width: 460px;
  max-height: 450px;
  padding: 24px;
  .addPhoneNumber__header {
    display: flex;
    justify-content: space-between;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .addPhoneNumber__body {
    position: relative;
    display: flex;
    margin: 30px 0;
    label {
      position: absolute;
      top: -6px;
      left: 15px;
      font-family: 'Ubuntu-Regular';
      padding: 0 5px;
      background: $white;
      color: $label;
      font-weight: 400;
      font-size: $twelveSize;
      line-height: $fourteenSize;
      z-index: 1;
    }
    input {
      width: 100%;
      height: 48px;
      font-size: 14px;
      border-radius: 8px;
      border: 1px solid $border;
      padding: 0 0 0 15px;
      box-sizing: border-box;
      color: $main-text;
      font-family: 'Ubuntu-Regular';
      outline: none;
      margin-bottom: 0;
    }
  }
  .addPhoneNumber__buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > *:first-child {
      width: 270px;
    }
  }
}
</style>
